import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { TextDisplay } from './TextDisplay';
import { IFormFieldText } from '.';

interface IProps {
  value?: string;
  previousValue?: string | null;
  onClose: () => void;
  config: IFormFieldText;
}

export const TextDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: IProps) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <TextDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? zeroState : <TextDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
